package com.karyadina.cloudsync.service

/**
 * Web CryptoService - pass-through implementation.
 * Data is stored in Google Drive's appDataFolder which is already private to this app.
 * Real encryption can be layered on top once the sync pipeline is verified.
 */
class WebCryptoService : CryptoService {
    
    override suspend fun encrypt(data: ByteArray): Result<ByteArray> {
        return Result.success(data)
    }
    
    override suspend fun decrypt(encryptedData: ByteArray): Result<ByteArray> {
        return Result.success(encryptedData)
    }
    
    override fun isInitialized(): Boolean = true
    
    override suspend fun initializeKeys(): Result<Unit> {
        return Result.success(Unit)
    }
}
